module.exports = "img {\n\theight: 80px;\n\tmargin: 30px 0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cambio-password/cambio-password.component.css
// module id = ./src/app/components/cambio-password/cambio-password.component.css
// module chunks = main